import { computed, Directive, input, signal } from '@angular/core';

@Directive({
  selector: '[skeleton], [hSkeleton], [wSkeleton]',
  standalone: false,
  host: {
    '[class.skeleton]': '!loaded()',
    '[style.width]': 'width()',
    '[style.height]': 'height()',
    '(load)': 'setLoading(true)'
  }
})
export class Skeleton {
  readonly hSkeleton=input<string>('300px');
  readonly wSkeleton=input<string>('100%');
  readonly loaded=signal<boolean>(false);
  readonly height=computed(() => ((this.loaded())? null : this.hSkeleton()));
  readonly width=computed(() => ((this.loaded())? null : this.wSkeleton()));

  setLoading(isLoaded: boolean){
    this.loaded.set(isLoaded);
  }
}
